import { render, staticRenderFns } from "./sideArrows.vue?vue&type=template&id=1150ab7b&scoped=true&"
import script from "./sideArrows.vue?vue&type=script&lang=js&"
export * from "./sideArrows.vue?vue&type=script&lang=js&"
import style0 from "./sideArrows.vue?vue&type=style&index=0&id=1150ab7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1150ab7b",
  null
  
)

export default component.exports